import { createTTL } from '@core/helpers/date'

const COOKIE_EXPIRATION_DATE = 6

export default {
  expires: createTTL({ months: COOKIE_EXPIRATION_DATE }).toUTCString(),
}
